// Clean, dependency-free flag SVGs so the EN/NL toggle renders the same on every
// platform (Chrome on Windows doesn't ship colour emoji fonts by default, which
// made the 🇬🇧/🇳🇱 characters fall back to text like "GB" / "NL").

export function FlagEN({ size = 18, className = '', title = 'English' }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 30"
            width={size * 1.5}
            height={size}
            role="img"
            aria-label={title}
            className={`shrink-0 rounded-[2px] ${className}`}
        >
            <clipPath id="flag-en-c"><path d="M0 0v30h60V0z" /></clipPath>
            <clipPath id="flag-en-d"><path d="M30 15h30v15zv15H0zH0V0zV0h30z" /></clipPath>
            <g clipPath="url(#flag-en-c)">
                <path fill="#012169" d="M0 0v30h60V0z" />
                <path stroke="#fff" strokeWidth="6" d="M0 0l60 30m0-30L0 30" />
                <path clipPath="url(#flag-en-d)" stroke="#C8102E" strokeWidth="4" d="M0 0l60 30m0-30L0 30" />
                <path stroke="#fff" strokeWidth="10" d="M30 0v30M0 15h60" />
                <path stroke="#C8102E" strokeWidth="6" d="M30 0v30M0 15h60" />
            </g>
        </svg>
    );
}

export function FlagNL({ size = 18, className = '', title = 'Nederlands' }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 9 6"
            width={size * 1.5}
            height={size}
            role="img"
            aria-label={title}
            className={`shrink-0 rounded-[2px] ${className}`}
        >
            <rect width="9" height="6" fill="#21468B" />
            <rect width="9" height="4" fill="#FFFFFF" />
            <rect width="9" height="2" fill="#AE1C28" />
        </svg>
    );
}
